const Container =  ({children}) => {
    return (
        <div className="
            max-w-[1320px]
            mx-auto
            xl:px-20
            md:px-10
            sm:px-2
            px-2
        ">
            {children}
        </div>
    )
}
export default Container;